
import { StyleEntry } from 'Shared/backend/styleUtils';
import { GridGapFields } from 'Shared/themes/GridGap';
import { ScrollbarColourFields } from 'Shared/themes/ScrollbarColour';
import { palette } from 'Shared/frontend/SettingsProvider';
import { resolveColour } from 'Shared/model/settingColour';

export function layoutStyles(sizes,_text): {[name: string]: StyleEntry}
{
	return {
		/* The scrollbar of a sideways-scrolling row of posters or menu items. Unlike the rest of this
		   catalogue this names the component it styles rather than landing on whatever it wraps, so it
		   can be turned on once for the whole venue - under 'Page styles' on /admin/settings - and reach
		   every scrolling row on every page. A venue that wants one row to differ can still add a
		   Tweak to it. */
		'Scrolling row': {
			explanation: 'Colour the scrollbar of a sideways-scrolling row of posters or menu items. Apply at the site level to colour every row on the site.',
			ui: ScrollbarColourFields,

			rules: [{
				location: () => ['**','posters'],
				css: (params = {}) => scrollbarColourRule(params.handle, params.track),
			}]
		},

		/* The gaps between the cells of the grid this wraps. The location is fixed at the wrapped
		   component, as the rest of this catalogue's are, so the style goes on the grid's own styles
		   wrapper; Tweaks carries the same property with a Selector for a grid further down. */
		'Grid gaps': {
			explanation: 'Set the gaps between the cells of a grid. Leave a box empty to keep the default gap for that direction.',
			ui: GridGapFields,

			rules: [{
				location: () => ['*'],
				css: (params = {}) => gridGapRule(params.columnGap, params.rowGap),
			}]
		},

		'Ignore page margins': {
			explanation: 'Allows the contents to extend to the edges of the page. Useful for banner images.',

			rules: [{
				location: () => ['*'],
				ignorePageMargins: () => true
			}]
		},

		//XXX modelled off The Townie club page.  XXX USED?
		'Narrow page': {
			explanation: 'Makes page narrower. Apply at the page level. Sometimes improves the appearance of the content.',
			rules: [{
				location: () => ['^','*'],
				css: () => ({
					maxWidth: 820,
					marginLeft: 'auto',
					marginRight: 'auto',
				})
			}]
		},

		'Responsive embed': {		//XXX cf breaking down into components? eg separate out iframe part
			explanation: 'Embed uses 100% width and most the height of a desktop.',   //XXX or 'embed'?
			rules: [{
				location: () => ['*'],
				css: () => ({
					width: '100%',
					display: 'inline-block',
					overflow: 'hidden',
					paddingBottom: '56.25%',
					position: 'relative',
					marginTop: '1em',
					height: 0,

					iframe: {
						left: 0,
						top: 0,
						height: '100%',
						width: '100%',
						position: 'absolute'
					}
				})
			}]
		}
	};
}


/* 'scrollbar-color' takes the handle colour then the track colour and can't mix a colour with 'auto',
   so a half-set pair fills the other side in from Content.tsx's own fallback. '!important' to beat the
   scrollbarColor in its scrollStyle(). */
function scrollbarColourRule(handle:any, track:any): object
{
	const resolvedHandle = resolveColour(handle, palette());
	const resolvedTrack = resolveColour(track, palette());

	if (resolvedHandle == '' && resolvedTrack == '')
		return {};

	return {scrollbarColor: `${resolvedHandle || 'black'} ${resolvedTrack || '#666363'} !important`};
}


/* Each gap dropped when unset, so a rule that sets only one axis leaves the other on Grid.tsx's
   default. A deliberate copy of the same builder in tweaksStyle.ts / ruleProperties.ts - the three
   style catalogues are kept apart so they can diverge. */
function gridGapRule(columnGap:any, rowGap:any): object
{
	const ret: any = {};
	if (columnGap != undefined && columnGap != '')
		ret.columnGap = columnGap;
	if (rowGap != undefined && rowGap != '')
		ret.rowGap = rowGap;
	return ret;
}

